import { render } from "./BlockLink.vue?vue&type=template&id=61bccaf9&scoped=true"
import script from "./BlockLink.vue?vue&type=script&lang=ts"
export * from "./BlockLink.vue?vue&type=script&lang=ts"

import "./BlockLink.vue?vue&type=style&index=0&id=61bccaf9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-61bccaf9"

export default script